/** External dependencies */
import Swiper from 'swiper/bundle';

export function swiperFromConfig(sliderContainer, userConfig) {
    const defaultConfig = {
        effect: 'slide',
        speed: 500,
        slidesPerView: 'auto',
        keyboard: true,
        loop: false,
        autoHeight: false,
        fadeEffect: false,
    };

    // sanity checks and configuration additions
    if (userConfig.autoplay === true) {
        userConfig.autoplay = {
            delay: userConfig.autoplayDelay ?? 5000,
            disableOnInteraction: userConfig.disableOnInteraction ?? true,
        };
    }

    // cleanup userConfig to prepare for later merging
    delete userConfig.autoplayDelay;
    delete userConfig.disableOnInteraction;

    if (userConfig.pagination === true) {
        userConfig.pagination = {
            el: userConfig.paginationEl ?? '.swiper-pagination',
            type: userConfig.paginationType ?? 'bullets',
            clickable: userConfig.paginationClickable ?? true,
        };
    }

    delete userConfig.paginationEl;
    delete userConfig.paginationType;
    delete userConfig.paginationClickable;

    if (userConfig.navigation === true) {
        userConfig.navigation = {
            nextEl: userConfig.navigationNextEl ?? '.button-next',
            prevEl: userConfig.navigationPrevEl ?? '.button-prev',
        };
    }

    delete userConfig.navigationNextEl;
    delete userConfig.navigationPrevEl;

    // merge together, later object props overwrite previous ones
    const swiperConfig = {
        ...defaultConfig,
        ...userConfig,
    };

    if (swiperConfig.effect === 'fade') {
        swiperConfig.fadeEffect = {
            crossFade: true,
        };
    }

    // compatibility with lazy load > but only if no init handler has been defined yet
    if (window.lazyLoadInstance && !swiperConfig.on?.init) {
        // set .on to an empty object if it is not yet defined
        swiperConfig.on = swiperConfig.on || {};

        // update lazload instance on swiper init event
        swiperConfig.on.init = () => {
            window.lazyLoadInstance.update();
        };
    }

    // check whether we are in a tab, since we cannot initialize swiper until the tab is visible
    const tabItem = sliderContainer.closest('.ct_tabitem');

    if (tabItem && !tabItem.classList.contains('active')) {
        const tabs = sliderContainer.closest('.ct_tab');
        const trigger = tabs.querySelector(`#${tabItem.getAttribute('aria-labelledby')}`);
        trigger.addEventListener('shown.bs.tab', () => {
            // init swiper
            initSwiper(sliderContainer, swiperConfig);
        });
    } else {
        // standard swiper initialization
        initSwiper(sliderContainer, swiperConfig);
    }
}

function initSwiper(sliderContainer, swiperConfig) {
    const swiper = new Swiper(sliderContainer, swiperConfig);

    // start autoplay if necessary
    swiperConfig.autoplay && !swiper.autoplay.running && swiper.autoplay.run();
}
